export enum EPlateCorner {
  Unknown = "unknown",
  TopLeft = "topLeft",
  TopRight = "topRight",
  BottomRight = "bottomRight",
  BottomLeft = "bottomLeft",
}

export enum EPlateCornerShorten {
  unknown = "unknown",
  topLeft = "TL",
  topRight = "TR",
  bottomRight = "BR",
  bottomLeft = "BL",
}

export enum EPlateCornerTooltip {
  unknown = "unknown",
  topLeft = "Top Left",
  topRight = "Top Right",
  bottomRight = "Bottom Right",
  bottomLeft = "Bottom Left",
}